import React, { Component } from 'react'
import { DropdownToggle } from 'reactstrap';
import Select from 'react-select';
import {Col, Dropdown, Modal, ModalHeader, ModalBody, CardTitle, Input, Button, Label, FormGroup, Alert} from "reactstrap"
import { AvForm } from 'availity-reactstrap-validation';
import { Link } from "react-router-dom";
import { victimAssessmentUrl, victimTagsUrl } from '../../helpers/url';


export default class AssessmentAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            success: false,
            successMessage: "",
            menu : false,
            modal_center: false,

            assessmentId: 0,
            assessment: '',
            tags: [],
            signature: '',
            note: '',
            victimId: 0,
            userId: "",
        }
        this.tog_center = this.tog_center.bind(this);
    }

    tog_center() {
        this.setState(prevState => ({
          modal_center: !prevState.modal_center
        }));
    }

    componentDidMount() {
        const jwt = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = jwt.jwtToken;
        fetch(victimTagsUrl, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken},
		}).then(res => res.json())
        .then((data) => {
            this.setState({
                tempAssessmentMultiSelect: data,
                loading: false,
            })
        })
    }

    submit = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;
        fetch(victimAssessmentUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                assessmentId: this.state.assessmentId,
                assessment: this.state.assessment,
                tags: this.state.tags,
                signature: this.state.signature,
                note: this.state.note,
                victimId: this.props.victimId,
                userId: userId,
            })
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                success: true,
                successMessage: "Submitted!"
            })
        })
    }

    stateSelect = (selected) => {
		let selectedOptions = [];
        selected.map(each => {
            if (each.value === 1) {
                selectedOptions.push(this.state.tempAssessmentMultiSelect[0]);
            } else if (each.value === 2) {
                selectedOptions.push(this.state.tempAssessmentMultiSelect[1]);
            } else if (each.value === 3) {
                selectedOptions.push(this.state.tempAssessmentMultiSelect[2]);
            } else if (each.value === 4) {
                selectedOptions.push(this.state.tempAssessmentMultiSelect[3]);
            }
        });
        let tempState = [...this.state.tags]
        tempState = selectedOptions;
        this.setState({
            tags: tempState
        });
    }

    assessmentStateSectionChange = (event) => {
        let targetId = event.target.id;
		let targetValue = event.target.value;
		let targetType = event.target.type;
        console.log(targetId, targetValue, targetType)
		if (targetType === 'text' || targetType === "textarea") {
            this.setState({
                [targetId]: targetValue,
			});
        }
        else if (targetType === 'number' || targetType === 'select-one') {
			if (targetValue === isNaN) {
				targetValue = 0;
			}
			this.setState({
				[targetId]: parseInt(targetValue),
			});
        }
    }




    render() {
        if (this.state.loading) {
            return (
                <React.Fragment>
                    <div>
                        LOADING
                    </div>
                </React.Fragment>
            )
        }
        return (
            <React.Fragment>
                            <Dropdown className="text-center mt-3" isOpen={this.state.menu} toggle={() => this.setState({menu : !this.state.menu})}>
                                <DropdownToggle tag="i" className="darrow-none card-drop" aria-expanded="false">
                                    <Link><i className="mdi mdi-book-plus-multiple-outline" onClick={this.tog_center}> Add Internal Assessment </i></Link>

                                    <Modal size="lg" isOpen={this.state.modal_center} toggle={this.tog_center} centered={true} >
                                        <ModalHeader toggle={() => this.setState({ modal_center: false })}> Assesment - Add </ModalHeader>
                                        <ModalBody>
                                        <CardTitle className="h5 mb-3 text-center">Internal Assessment</CardTitle>
                                        <div className="mt-5 text-center">
                                            <Alert color="success" isOpen={this.state.success} toggle={() => {this.setState({success:!this.state.success})}}>
                                                {this.state.successMessage}
                                            </Alert>
                                        </div>
                                            <AvForm className="form-horizontal">
                                                <FormGroup row>
                                                    <Label htmlFor="denetention-clarification" md="2" className="form-label">
                                                        Assessment
                                                    </Label>
                                                    <Col md={9}>
                                                        <Input
                                                            type="textarea"
                                                            id="assessment"
                                                            rows="2"
                                                            placeholder="Assessment Evaluation"
                                                            value={this.state.assessment}
                                                            onChange={event => {
                                                                this.assessmentStateSectionChange(event);
                                                            }}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label className="col-md-2 col-form-label">Tags</Label>
                                                    <Col md={9}>
                                                        <Select
                                                            isMulti
                                                            name="colors"
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            options={this.state.tempAssessmentMultiSelect.map((option, idx) => ({
                                                                value: option.tagId,
                                                                label: option.tagName,
                                                            }))}
                                                            onChange={selected => {
                                                                this.stateSelect(selected);
                                                            }}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label htmlFor="denetention-clarification" md="2" className="form-label">
                                                        Assessment Notes
                                                    </Label>
                                                    <Col md={9}>
                                                        <Input
                                                            type="textarea"
                                                            id="note"
                                                            rows="2"
                                                            placeholder="Note"
                                                            value={this.state.note}
                                                            onChange={event => {
                                                                this.assessmentStateSectionChange(event);
                                                            }}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label htmlFor="example-number-input" className="col-md-2 col-form-label">
                                                        Signature
                                                    </Label>
                                                    <Col md={9}>
                                                        <Input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Signature"
                                                            id="signature"
                                                            onChange={event => {
                                                                this.assessmentStateSectionChange(event);
                                                            }}
                                                            value={this.state.signature}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <Button
                                                    to="#"
                                                    onClick={() => this.submit()}>
                                                    Submit
                                                </Button>
                                            </AvForm>
                                        </ModalBody>
                                    </Modal>
                                </DropdownToggle>
                            </Dropdown>
            </React.Fragment>
        )
    }
}
